import React from 'react';

import { Box, SxProps, Typography, useTheme } from '@mui/material';
import { CustomAvatar } from '@europrocurement/flexy-components';

import { UtilisateurApiObject } from '@europrocurement/l2d-domain';

export type SearchMembersWidgetProps = {
    candidate: UtilisateurApiObject;
    setCandidate?: React.Dispatch<React.SetStateAction<UtilisateurApiObject>> | undefined;
    sx?: SxProps;
};

/**
 * Lighter widget for member search modal.
 *
 * Widget size with padding is 500x51px (500x74px start)
 * Margin bottom is 10px
 */
export const SearchMembersWidget: React.FunctionComponent<SearchMembersWidgetProps> = function ({
    candidate,
    setCandidate,
    sx,
}) {
    const theme = useTheme();

    const handleClick = () => {
        if (setCandidate) {
            setCandidate(candidate);
        }
    };

    return (
        <Box
            data-testid="search-members-widget"
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="start"
            onClick={() => handleClick()}
            sx={{
                margin: '0px',
                marginBottom: '8px',
                padding: '8px',
                backgroundColor: theme.palette.background.default,
                borderRadius: '8px',
                ...sx,
            }}
        >
            {/* Base container */}
            <Box
                display="flex"
                alignItems="center"
                justifyContent="start"
                width="100%"
            >
                {/* Avatar container */}
                <Box
                    sx={{
                        marginRight: '20px',
                    }}
                >
                    <CustomAvatar
                        firstName={candidate.prenom}
                        lastName={candidate.nom}
                        keycloakId={candidate.userIdentifier || undefined}
                        sx={{
                            width: 35,
                            height: 35,
                            borderRadius: '50px',
                            fontSize: '15px',
                        }}
                    />
                </Box>

                {/* Name + Mail container */}
                <Box
                    display="flex"
                    flexDirection="column"
                    alignItems="start"
                    sx={{
                        marginRight: '10px',
                        width: '80%',
                    }}
                >
                    <Typography
                        variant="l2dh7"
                        sx={{ lineHeight: '1.4' }}
                    >
                        {candidate.prenom} {candidate.nom}
                    </Typography>

                    <Typography
                        variant="l2dbodyxs"
                        color="text.gris50"
                    >
                        {candidate.mail}
                    </Typography>
                </Box>
            </Box>
        </Box>
    );
};
